import {
  CONTENT_DATA_PATH_SERVICE,
  USER_ISLOGGEDIN_SERVICE_PATH,
  USER_LOGIN_PATH_SERVICE,
  CONTENT_RECOMMENDATIONS_PATH_SERVICE,
  USER_LOGOUT_PATH_SERVICE,
  SEARCH_LINEAL_PREDICTIVE,
  CMS_LEVEL_PATH_SERVICES,
  CMS_LEVEL_USER_PATH_SERVICES,
  CMS_SUPERHIGHLIGHT_PATH_SERVICES,
  CONTENT_LIST_PATH_SERVICES,
  USER_SEEN_PATH_SERVICES,
  FAVORITE_USER_PATH_SERVICES,
  RECORDING_LIST_PATH_SERVICES,
  PURCHASE_ACTIVE_PATH_SERVICES,
  WORKFLOWSTART_PATH_SERVICE,
  PURCHASE_NODE_ID_PATH_SERVICES,
  MULTI_PBI_PATH_SERVICES,
  MULTI_CONTENT_SEARCH_PATH_SERVICES,
  USER_CHANNELS_SEEN_PATH,
  EPG_EVENTS_BY_GENRE_PATH,
  PAYWAY_V1_LINEALCHANNELS_PATH_SERVICE,
  SERVICES_USER_REGISTER_PATH_SERVICES,
  USER_RECOMMENDATIONS,
} from 'api/services/content/paths';
import { EPG_LINEUP_SERVICE } from 'api/services/epg/paths';
import { NAV_EXPERIENCE_PATH_SERVICE } from 'api/services/nav/paths';
import {
  PAYWAY_PROFILE_PATH_SERVICE,
  PURCHASE_BUTTON_INFO_SERVICE,
} from 'api/services/payway/paths';
import { PATH_PLANS_OFFERS } from 'api/services/plan/path';
import { PLAYER_GETMEDIA_PATH, PLAYER_GETMEDIA_PATH_V3 } from 'api/services/player/paths';
import {
  USER_AUD_PREFERENCES_PATH,
  USER_FAVORITE_ADD_PATH,
  USER_FAVORITE_DEL_PATH,
  USER_STATUS_CONTROL_PIN_CHANNEL_CHECK_PATH,
  USER_STATUS_CONTROL_PIN_CHECK_PATH,
  USER_STATUS_CONTROL_PIN_PATH,
  USER_SUPERHIGHLIGHT_SERVICE,
} from 'api/services/user/paths';

export const SWAGGER_ENDPOINTS_WHITELIST = [
  PAYWAY_V1_LINEALCHANNELS_PATH_SERVICE,
  CONTENT_DATA_PATH_SERVICE,
  USER_LOGOUT_PATH_SERVICE,
  CONTENT_RECOMMENDATIONS_PATH_SERVICE,
  SEARCH_LINEAL_PREDICTIVE,
  USER_LOGIN_PATH_SERVICE,
  USER_ISLOGGEDIN_SERVICE_PATH,
  USER_SUPERHIGHLIGHT_SERVICE,
  PLAYER_GETMEDIA_PATH,
  PURCHASE_BUTTON_INFO_SERVICE,
  NAV_EXPERIENCE_PATH_SERVICE,
  CMS_LEVEL_PATH_SERVICES,
  CMS_LEVEL_USER_PATH_SERVICES,
  CMS_SUPERHIGHLIGHT_PATH_SERVICES,
  CONTENT_LIST_PATH_SERVICES,
  USER_SEEN_PATH_SERVICES,
  FAVORITE_USER_PATH_SERVICES,
  RECORDING_LIST_PATH_SERVICES,
  PURCHASE_ACTIVE_PATH_SERVICES,
  PURCHASE_NODE_ID_PATH_SERVICES,
  WORKFLOWSTART_PATH_SERVICE,
  MULTI_PBI_PATH_SERVICES,
  MULTI_CONTENT_SEARCH_PATH_SERVICES,
  USER_FAVORITE_ADD_PATH,
  USER_FAVORITE_DEL_PATH,
  USER_STATUS_CONTROL_PIN_PATH,
  USER_STATUS_CONTROL_PIN_CHANNEL_CHECK_PATH,
  USER_STATUS_CONTROL_PIN_CHECK_PATH,
  PAYWAY_PROFILE_PATH_SERVICE,
  PLAYER_GETMEDIA_PATH_V3,
  USER_CHANNELS_SEEN_PATH,
  EPG_LINEUP_SERVICE
];

export const SWAGGER_ENDPOINTS_TRANSFORM_RESPONSE = [
  SEARCH_LINEAL_PREDICTIVE,
  CMS_LEVEL_PATH_SERVICES,
  CMS_LEVEL_USER_PATH_SERVICES,
  USER_SEEN_PATH_SERVICES,
  FAVORITE_USER_PATH_SERVICES,
  PURCHASE_ACTIVE_PATH_SERVICES,
  NAV_EXPERIENCE_PATH_SERVICE,
  MULTI_PBI_PATH_SERVICES,
  USER_FAVORITE_ADD_PATH,
  USER_FAVORITE_DEL_PATH,
  USER_CHANNELS_SEEN_PATH,
  EPG_EVENTS_BY_GENRE_PATH,
  USER_RECOMMENDATIONS,
];
export const SWAGGER_ENDPOINTS_TRANSFORM_REQUEST = [
  USER_AUD_PREFERENCES_PATH,
  CMS_LEVEL_PATH_SERVICES,
  CMS_LEVEL_USER_PATH_SERVICES,
  CONTENT_DATA_PATH_SERVICE,
  PURCHASE_NODE_ID_PATH_SERVICES,
  MULTI_PBI_PATH_SERVICES,
  MULTI_CONTENT_SEARCH_PATH_SERVICES,
  WORKFLOWSTART_PATH_SERVICE,
  NAV_EXPERIENCE_PATH_SERVICE,
  PATH_PLANS_OFFERS,
  PURCHASE_BUTTON_INFO_SERVICE,
  SEARCH_LINEAL_PREDICTIVE,
  PLAYER_GETMEDIA_PATH,
  CONTENT_RECOMMENDATIONS_PATH_SERVICE,
  FAVORITE_USER_PATH_SERVICES,
  USER_SEEN_PATH_SERVICES,
  USER_CHANNELS_SEEN_PATH,
  EPG_EVENTS_BY_GENRE_PATH,
  USER_RECOMMENDATIONS,

];

export const SWAGGER_ENDPOITS_WHITOUT_HKS = [
  CONTENT_DATA_PATH_SERVICE,
  MULTI_PBI_PATH_SERVICES,
  MULTI_CONTENT_SEARCH_PATH_SERVICES,
  CMS_LEVEL_PATH_SERVICES,
  CMS_LEVEL_USER_PATH_SERVICES,
  NAV_EXPERIENCE_PATH_SERVICE,
  PATH_PLANS_OFFERS,
  PURCHASE_BUTTON_INFO_SERVICE,
  SEARCH_LINEAL_PREDICTIVE,
  PLAYER_GETMEDIA_PATH,
  CONTENT_RECOMMENDATIONS_PATH_SERVICE,
  PLAYER_GETMEDIA_PATH_V3,
];

export const removeServicesParams = {
  params: [
    {
      path: '/services/content/list',
      remove: ['module_version'],
    },
    {
      path: CONTENT_LIST_PATH_SERVICES,
      remove: ['module_version'],
    },
    {
      path: USER_LOGIN_PATH_SERVICE,
      remove: ['user_id', 'user_token'],
    },
    {
      path: USER_LOGOUT_PATH_SERVICE,
      remove: ['user_token'],
    },
    {
      path: SERVICES_USER_REGISTER_PATH_SERVICES,
      remove: ['user_id', 'user_token'],
    },
    {
      path: USER_ISLOGGEDIN_SERVICE_PATH,
      remove: ['user_token'],
    },
  ],
  headers: [
    {
      path: USER_SUPERHIGHLIGHT_SERVICE,
      remove: ['Authorization', 'user-token'],
    },
    {
      path: CMS_LEVEL_PATH_SERVICES,
      remove: ['Authorization', 'user-token'],
    },
    {
      path: '/services/content/list',
      remove: ['Authorization', 'user-token'],
    },
    {
      path: CONTENT_LIST_PATH_SERVICES,
      remove: ['Authorization', 'user-token'],
    },
    {
      path: CMS_SUPERHIGHLIGHT_PATH_SERVICES,
      remove: ['Authorization', 'user-token'],
    },
    {
      path: USER_LOGIN_PATH_SERVICE,
      remove: ['Authorization', 'user-token'],
    },
    {
      path: USER_LOGOUT_PATH_SERVICE,
      remove: ['Authorization', 'user-token'],
    },
    {
      path: SERVICES_USER_REGISTER_PATH_SERVICES,
      remove: ['Authorization', 'user-token'],
    },
    {
      path: USER_CHANNELS_SEEN_PATH,
      remove: ['user-token'],
    },
    {
      path: EPG_EVENTS_BY_GENRE_PATH,
      remove: ['user-token'],
    },
    {
      path: USER_ISLOGGEDIN_SERVICE_PATH,
      remove: ['Authorization'],
    }
  ],
};
